import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { User } from '@ubie/core';

@Component({
  selector: 'acl-installation-installer',
  standalone: false,
  templateUrl: './installation-installer.component.html',
  styleUrl: './installation-installer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationInstallerComponent {
  readonly installer = input<User | null>(null);
  readonly installer2 = input<User | null>(null);
  readonly canDeleteFirstInstaller = input<boolean>(false);
  readonly canDeleteSecondInstaller = input<boolean>(false);
  readonly canAddInstaller = input<boolean>(false);
  readonly isCurrentUserInstaller2 = input<boolean>(false);

  readonly deleteFirstInstaller = output<void>();
  readonly deleteSecondInstaller = output<void>();
  readonly addInstaller = output<1 | 2>();
}
